import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MarkerF } from '@react-google-maps/api'
import { DateTime } from 'luxon'
import * as React from 'react'
import { deviceFromPet } from '../../../helpers/dataHelpers.ts'
import { IDeviceStatus, IPet } from '../../../interfaces/types.ts'
import mapStore from '../../../store/mapStore.ts'
import { DATETIME_MED_WITH_WEEKDAY } from '../../../helpers/dateFormats.ts'
import { getPawIcon } from '../components/icons.ts'
import { OverlayPanel } from '../components/OverlayPanel.tsx'
import './style.css'
import authStore from '../../../store/authStore.ts'

interface Props {
    pet: IPet
    position: google.maps.LatLng
    status: IDeviceStatus
}

export const PetMarker: React.FC<Props> = (props) => {
    const { pet, position } = props
    const [open, setOpen] = React.useState(false)

    const markerInfo = mapStore(s => s.markerInfo)

    React.useEffect(() => {
        if (!markerInfo) {
            setOpen(false)
        }
    }, [markerInfo])

    const handleClick = () => {
        setOpen(!open)
        mapStore.getState().setMarkerInfo(!open ? pet._id : null)
    }

    const device = deviceFromPet(pet)
    if (!device?.lastLocation || !Object.keys(device.lastLocation).length) {
        return null
    }

    const date = DateTime.fromISO(device.lastLocation.properties.receivedTime)
        .setZone(authStore.getState().effectiveTimezone().value)
        .toLocaleString(DATETIME_MED_WITH_WEEKDAY)

    const petInfo = (
        <div className={'flex flex-col justify-start gap-2 select-none without-ring text-primary'}>
            <div className={'flex flex-row justify-between align-center'}>
                <div className={'w-4 h-1'} />
                <div className={'text-lg font-semibold -mb-2'}>{pet.petName}</div>
                <div onClick={() => setOpen(false)}>
                    <FontAwesomeIcon icon={faClose} fontSize={'small'} className={'focus:outline-none'} />
                </div>
            </div>

            <div className={'flex flex-row justify-center text-lg align-center'}>
                <div>{date}</div>
            </div>
        </div>
    )

    return (
        <div className={'select-none no-outline'}>
            {open ?
                <OverlayPanel onClick={handleClick} position={position}>
                    {petInfo}
                </OverlayPanel>
                : null}
            <MarkerF key={pet._id}
                position={position}
                icon={getPawIcon(pet.iconColor || '', google)}
                onClick={handleClick}
            />
        </div>
    )
}
